var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM18 9C18.5523 9 19 9.44772 19 10V16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16V12.414L10.7071 18.7071C10.3466 19.0676 9.77939 19.0953 9.3871 18.7903L9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L15.584 11H12C11.4872 11 11.0645 10.614 11.0067 10.1166L11 10C11 9.44772 11.4477 9 12 9H18Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCircleOutline);
export default __webpack_public_path__ + "static/media/link_circle_outline.800e94caef5295cac7d9bd4adf3c7855.svg";
export { ForwardRef as ReactComponent };